import useCatalogSectionProducts from './CatalogSectionProducts/useCatalogSectionProducts';
import useCatalogSectionPromo from './CatalogSectionPromo/useCatalogSectionPromo';
import useCatalogSectionProductsTabs from './CatalogSectionProductsTabs/useCatalogSectionProductsTabs';

const dataPreloadHooks = {
  'catalog-section-products': useCatalogSectionProducts,
  'catalog-section-promo': useCatalogSectionPromo,
  'catalog-section-products-tabs': useCatalogSectionProductsTabs,
};

export default dataPreloadHooks;
